import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Allproduct2.css";
import Adobe from "../../assest/products/adobe.jpg";
import Audiotechnica from "../../assest/products/audio technica.jpg";
import Avaya from "../../assest/products/avaya.jpg";
import Acer from "../../assest/products/acer.jpg";
import Asus from "../../assest/products/asus.jpg";
import VeeamVVAR from "../../assest/products/veeam-vvar.png";
import VeeamVCSP from "../../assest/products/veeam-vcsp.png";
import AOC from "../../assest/products/aoc.jpg";
import Arista from "../../assest/products/arista.jpg";
import APC from "../../assest/products/apc.jpg";
import Autocad from "../../assest/products/autocad.jpg";
import Brocade from "../../assest/products/brocade.jpg";
import Canon from "../../assest/products/cannon.jpg";
import Cisco from "../../assest/products/cisco.jpg";
import CSBBattery from "../../assest/products/csb battery.jpg";
import CyberPower from "../../assest/products/cyberpower.jpg";
import Dahua from "../../assest/products/dahua.jpg";
import Dell from "../../assest/products/dell.jpg";
import DLink from "../../assest/products/dlink.jpg";
import Ezviv from "../../assest/products/ezviz.jpg";
import Eaton from "../../assest/products/eaton.jpg";
import Fortigate from "../../assest/products/fortigate.jpg";
import Fujitsu from "../../assest/products/fujitsu.jpg";
import F5 from "../../assest/products/f5.jpg";
import Furukawa from "../../assest/products/furukawa.jpg";
import Glink from "../../assest/products/glink.png";
import Global from "../../assest/products/global power.jpg";
import Honeywell from "../../assest/products/honeywell.jpg";
import Hikvision from "../../assest/products/hikvision.jpg";
import HiLook from "../../assest/products/hilook.jpg";
import H3C from "../../assest/products/h3c.jpg";
import HPEAruba from "../../assest/products/hpe aruba.jpg";
import HP from "../../assest/products/hp.jpg";
import HPEnterprise from "../../assest/products/hpe.jpg";
import Hip from "../../assest/products/hip.jpg";
import IBM from "../../assest/products/ibm.jpg";
import Imou from "../../assest/products/imou.jpg";
import Lenovo from "../../assest/products/lenovo.jpg";
import Logitech from "../../assest/products/logitec.jpg";
import LG from "../../assest/products/lg.jpg";
import Linksys from "../../assest/products/linksys.jpg";
import Maxhub from "../../assest/products/maxhub.jpg";
import Microsoft from "../../assest/products/microsoft.jpg";
import Mercusys from "../../assest/products/mercusys.jpg";
import Moxa from "../../assest/products/moxa.jpg";
import Nikon from "../../assest/products/nikon.jpg";
import Nutanix from "../../assest/products/nutanix.jpg";
import Netapp from "../../assest/products/netapp.jpg";
import Olympus from "../../assest/products/olympus.jpg";
import Oracle from "../../assest/products/oracle.jpg";
import OKI from "../../assest/products/oki.jpg";
import Panasonic from "../../assest/products/panasonic.jpg";
import PaloAltoNetwork from "../../assest/products/paloalto.jpg";
import Philips from "../../assest/products/philips.jpg";
import Presentations2Go from "../../assest/products/p2g.jpg";
import Rackus from "../../assest/products/rackus.jpg";
import Redhat from "../../assest/products/redhat.jpg";
import Ruijie from "../../assest/products/ruijie.jpg";
import Symantec from "../../assest/products/symantec.jpg";
import Sonicwall from "../../assest/products/sonic wall.jpg";
import Samsung from "../../assest/products/samsung.jpg";
import Solarwind from "../../assest/products/solarwind.jpg";
import Trend from "../../assest/products/trend.jpg";
import Toshiba from "../../assest/products/toshiba.jpg";
import Teltonika from "../../assest/products/teltonika.jpg";
import TPLink from "../../assest/products/tp link.jpg";
import Uniview from "../../assest/products/uniview.jpg";
import Ubiquiti from "../../assest/products/ubiquiti.jpg";
import Vmware from "../../assest/products/vmware.jpg";
import Vertiv from "../../assest/products/vertiv.jpg";
import Xioami from "../../assest/products/xioami.jpg";
import Yealink from "../../assest/products/yealink.jpg";
import Zoom from "../../assest/products/zoom.jpg";
import ZTE from "../../assest/products/zte.jpg";
import ZyXel from "../../assest/products/zyxel.jpg";
import Hisense from "../../assest/products/hisense.jpg";

const AllProduct2 = () => {
  const [selectedLetter, setSelectedLetter] = useState("All");

  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };
  const products = useMemo(
    () => ({
      A: [
        {
          name: "Adobe",
          category: "All Applications",
          logo: Adobe,
          link: "https://www.adobe.com",
        },
        {
          name: "Audio-technica",
          category: "Conference",
          logo: Audiotechnica,
          link: "https://audiotechnica.bentoweb.com/th",
        },
        {
          name: "Avaya",
          category: "Conference",
          logo: Avaya,
          link: "https://www.avaya.com",
        },
        {
          name: "Acer",
          category: "Laptop & PC",
          logo: Acer,
          link: "https://www.acer.com",
        },
        {
          name: "Asus",
          category: "Laptop & PC",
          logo: Asus,
          link: "https://www.asus.com/th/",
        },
        {
          name: "AOC",
          category: "Monitor",
          logo: AOC,
          link: "https://aocmonitor.com/th",
        },
        {
          name: "Arista",
          category: "Network",
          logo: Arista,
          link: "https://www.arista.com/en/",
        },
        {
          name: "APC",
          category: "Protect your power failure & UPS",
          logo: APC,
          link: "https://www.apc.com/th",
        },
        {
          name: "Autocad",
          category: "3D",
          logo: Autocad,
          link: "https://www.autodesk.com/products/autocad/overview",
        },
      ],
      B: [
        {
          name: "Brocade",
          category: "Fiber Switch",
          logo: Brocade,
          link: "https://www.broadcom.com/products/storage/fibre-channel-networking",
        },
      ],
      C: [
        {
          name: "Canon",
          category: "Camera",
          logo: Canon,
          link: "https://th.canon/",
        },
        {
          name: "Cisco",
          category: "Network & Server",
          logo: Cisco,
          link: "https://www.cisco.com/",
        },
        {
          name: "CSBBattery",
          category: "UPS",
          logo: CSBBattery,
          link: "https://www.csbbattery.com/",
        },
        {
          name: "CyberPower",
          category: "UPS",
          logo: CyberPower,
          link: "https://www.cyberpower.com/",
        },
      ],
      D: [
        {
          name: "Dahua",
          category: "CCTV",
          logo: Dahua,
          link: "https://www.dahuasecurity.com/",
        },
        {
          name: "Dell",
          category: "Laptop & PC & Server Storage",
          logo: Dell,
          link: "https://www.dell.com/",
        },
        {
          name: "D-Link",
          category: "Network",
          logo: DLink,
          link: "https://www.dlink.com/",
        },
      ],
      E: [
        {
          name: "Ezviv",
          category: "CCTV",
          logo: Ezviv,
          link: "https://www.ezviz.com/",
        },
        {
          name: "Eaton",
          category: "UPS",
          logo: Eaton,
          link: "https://www.eaton.com/",
        },
      ],
      F: [
        {
          name: "Fortigate",
          category: "Firewall & Security",
          logo: Fortigate,
          link: "https://www.fortinet.com/products/next-generation-firewall/fortigate",
        },
        {
          name: "Fujitsu",
          category: "Laptop & Printer",
          logo: Fujitsu,
          link: "https://www.fujitsu.com/",
        },
        {
          name: "F5",
          category: "Load Balance and Security",
          logo: F5,
          link: "https://www.f5.com/",
        },
        {
          name: "Furukawa",
          category: "Network",
          logo: Furukawa,
          link: "https://furukawaelectric.com/",
        },
      ],
      G: [
        {
          name: "Glink",
          category: "Network",
          logo: Glink,
          link: "https://www.glink.co.th/",
        },
        {
          name: "Global power",
          category: "UPS",
          logo: Global,
          link: "https://www.globalpower.com/",
        },
      ],
      H: [
        {
          name: "Honeywell",
          category: "Barcode Scanner",
          logo: Honeywell,
          link: "https://www.honeywell.com/",
        },
        {
          name: "Hikvision",
          category: "CCTV",
          logo: Hikvision,
          link: "https://www.hikvision.com/th/",
        },
        {
          name: "HiLook",
          category: "CCTV",
          logo: HiLook,
          link: "https://www.hikvision.com/th/",
        },
        {
          name: "Hip",
          category: "CCTV",
          logo: Hip,
          link: "https://www.hikvision.com/th/",
        },
        {
          name: "H3C",
          category: "Network",
          logo: H3C,
          link: "https://www.h3c.com/en/",
        },
        {
          name: "HPE Aruba",
          category: "Network",
          logo: HPEAruba,
          link: "https://www.arubanetworks.com/",
        },
        {
          name: "HP",
          category: "PC & Laptop",
          logo: HP,
          link: "https://www.hp.com/",
        },
        {
          name: "HP Enterprise",
          category: "Server Storage and Network",
          logo: HPEnterprise,
          link: "https://www.hpe.com/",
        },
        {
          name: "Hisense",
          category: "TV",
          logo: Hisense,
          link: "https://www.hisense.co.th/",
        },
      ],
      I: [
        {
          name: "Imou",
          category: "CCTV",
          logo: Imou,
          link: "https://www.imoulife.com/",
        },
        {
          name: "IBM",
          category: "Server & Storage",
          logo: IBM,
          link: "https://www.ibm.com/",
        },
      ],
      L: [
        {
          name: "Lenovo",
          category: "Conference & Laptop & PC & Server Storage",
          logo: Lenovo,
          link: "https://www.lenovo.com/th/th/",
        },
        {
          name: "Logitech",
          category: "Conference",
          logo: Logitech,
          link: "https://www.logitech.com/th-th",
        },
        {
          name: "LG",
          category: "Monitor & TV",
          logo: LG,
          link: "https://www.lg.com/th",
        },
        {
          name: "Linksys",
          category: "Network",
          logo: Linksys,
          link: "https://www.linksys.com/th/",
        },
      ],
      M: [
        {
          name: "Maxhub",
          category: "Conference & Led & TV",
          logo: Maxhub,
          link: "https://www.maxhub.com/",
        },
        {
          name: "Microsoft",
          category: "MS Windows & MS Applications",
          logo: Microsoft,
          link: "https://www.microsoft.com/th-th",
        },
        {
          name: "Mercusys",
          category: "Network",
          logo: Mercusys,
          link: "https://www.mercusys.com/th/",
        },
        {
          name: "Moxa",
          category: "Network",
          logo: Moxa,
          link: "https://www.moxa.com/en",
        },
      ],
      N: [
        {
          name: "Nikon",
          category: "Camera",
          logo: Nikon,
          link: "https://www.nikon.co.th/",
        },
        {
          name: "Nutanix",
          category: "Number 1 Hyperconvergence",
          logo: Nutanix,
          link: "https://www.nutanix.com/",
        },
        {
          name: "Netapp",
          category: "Storage",
          logo: Netapp,
          link: "https://www.netapp.com/",
        },
      ],
      O: [
        {
          name: "Olympus",
          category: "Camera",
          logo: Olympus,
          link: "https://www.oki.com/th/printing/products/index.html",
        },
        {
          name: "Oracle",
          category: "Database Leader & Middleware",
          logo: Oracle,
          link: "https://www.oracle.com/th/",
        },
        {
          name: "OKI",
          category: "Printer",
          logo: OKI,
          link: "https://www.oki.com/th/",
        },
        {
          name: "Oracle",
          category: "Unix Server",
          logo: Oracle,
          link: "https://www.oracle.com/th/",
        },
      ],
      P: [
        {
          name: "Panasonic",
          category: "Camera & Conference & Laptop",
          logo: Panasonic,
          link: "https://www.panasonic.com/th/",
        },
        {
          name: "Palo Alto Network",
          category: "Firewall Leader",
          logo: PaloAltoNetwork,
          link: "https://www.paloaltonetworks.com/",
        },
        {
          name: "Philips",
          category: "Monitor",
          logo: Philips,
          link: "https://www.philips.co.th/",
        },
        {
          name: "Presentations2Go",
          category: "The Best Classroom Capturing",
          logo: Presentations2Go,
          link: "https://www.presentations2go.com/",
        },
      ],
      R: [
        {
          name: "Rackus",
          category: "Network & Wifi",
          logo: Rackus,
          link: "https://www.rackus.com/",
        },
        {
          name: "Red hat",
          category: "Number 1 Open Source Company",
          logo: Redhat,
          link: "https://www.redhat.com/th",
        },
        {
          name: "Ruijie",
          category: "Network",
          logo: Ruijie,
          link: "https://www.ruijie.com/",
        },
      ],
      S: [
        {
          name: "Symantec",
          category: "Data Protection and Security",
          logo: Symantec,
          link: "https://www.broadcom.com/company/newsroom/press-releases?filtr=Symantec",
        },
        {
          name: "SonicWall",
          category: "Firewall",
          logo: Sonicwall,
          link: "https://www.sonicwall.com/",
        },
        {
          name: "Samsung",
          category: "LFD & Monitor & Phone & Tablet",
          logo: Samsung,
          link: "https://www.samsung.com/th/",
        },
        {
          name: "SolarWinds",
          category: "Network & System Monitoring",
          logo: Solarwind,
          link: "https://www.solarwinds.com/",
        },
      ],
      T: [
        {
          name: "Trend Micro",
          category: "Antivirus",
          logo: Trend,
          link: "https://www.trendmicro.com/th/th/",
        },
        {
          name: "Toshiba",
          category: "Laptop",
          logo: Toshiba,
          link: "https://www.toshiba.co.th/",
        },
        {
          name: "Teltonika",
          category: "Network",
          logo: Teltonika,
          link: "https://teltonika-networks.com/",
        },
        {
          name: "TP-Link",
          category: "Network",
          logo: TPLink,
          link: "https://www.tp-link.com/th/",
        },
      ],
      U: [
        {
          name: "Uniview",
          category: "CCTV",
          logo: Uniview,
          link: "https://www.uniview.com/",
        },
        {
          name: "Ubiquiti",
          category: "Network",
          logo: Ubiquiti,
          link: "https://www.ui.com/",
        },
      ],
      V: [
        {
          name: "Veeam VVAR",
          category: "Value-Added Reseller",
          logo: VeeamVVAR,
          link: "/product/veeam-vvar",
          type: "internal",
        },
        {
          name: "Veeam VCSP",
          category: "Veeam Cloud Service Provider",
          logo: VeeamVCSP,
          link: "/product/veeam-vcsp",
          type: "internal",
        },
        {
          name: "Vmware",
          category: "The Best Virtualization Software",
          logo: Vmware,
          link: "https://www.vmware.com/",
        },
        {
          name: "Vertiv",
          category: "UPS",
          logo: Vertiv,
          link: "https://www.vertiv.com/",
        },
      ],
      X: [
        {
          name: "Xiaomi",
          category: "Home appearance",
          logo: Xioami,
          link: "https://www.mi.com/th/",
        },
      ],
      Y: [
        {
          name: "Yealink",
          category: "Conference & Headset",
          logo: Yealink,
          link: "https://www.yealink.com/",
        },
      ],
      Z: [
        {
          name: "Zoom",
          category: "Conference",
          logo: Zoom,
          link: "https://zoom.us/",
        },
        {
          name: "ZTE",
          category: "Network",
          logo: ZTE,
          link: "https://www.zte.com.cn/global/",
        },
        {
          name: "ZyXel",
          category: "Network",
          logo: ZyXel,
          link: "https://www.zyxel.com/",
        },
      ],
    }),
    [],
  );

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
  };

  const handleProductClick = (e, product) => {
    if (product.type === "internal") {
      e.preventDefault();
      navigate(product.link);
    }
  };

  const filteredProducts =
    selectedLetter === "All"
      ? Object.values(products).flat()
      : products[selectedLetter] || [];

  return (
    <div className="product-page-container">
      <div className="product-introduction">
        <h1>All Products</h1>
        <p>
          Proscope can provide all hardware under these brand to our customer.
          Please contact us if you can not find any product under these brand.
          We will be very appreciate to support you.
        </p>
        <div className="product-categories">
          <div className="category-header">
            <h2>A-Z</h2>
            <div className="category-tags">
              <span
                className="category-tag hardware-tag"
                onClick={() => handleNavigation("/producthardware")}
              >
                <i className="icon-hardware"></i>
                Hardwares
              </span>
              <span
                className="category-tag software-tag"
                onClick={() => handleNavigation("/productsoftware")}
              >
                <i className="icon-software"></i>
                Softwares
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="all-product-container">
        <div className="alphabet-selector">
          {["All", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")].map((letter) => (
            <span
              key={letter}
              className={`alphabet ${letter === selectedLetter ? "active" : ""}`}
              onClick={() => handleLetterClick(letter)}
            >
              {letter}
            </span>
          ))}
        </div>

        <div className="product-list">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product, index) => (
              <a
                key={index}
                href={product.link}
                target={product.type === "internal" ? "_self" : "_blank"}
                rel="noopener noreferrer"
                className="product-item"
                onClick={(e) => handleProductClick(e, product)}
              >
                <img
                  src={product.logo}
                  alt={product.name}
                  className="product-logo"
                />
                <p>{product.name}</p>
                <div className="tooltip-wrapper">
                  <p className="product-category">{product.category}</p>
                  <span className="tooltip-text">{product.category}</span>
                </div>
              </a>
            ))
          ) : (
            <p className="no-products">
              No products available for this letter.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllProduct2;
